import styles from './footer.module.css';

const Footer = () => {
    const socials = [
        {
            name: 'Facebook',
            href: 'https://facebook.com/merilite',
            icon: (
                <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                    <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
                </svg>
            ),
        },
        {
            name: 'Instagram',
            href: 'https://instagram.com/merilite.together',
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                    <circle cx="12" cy="12" r="4"/>
                    <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none"/>
                </svg>
            ),
        },
        {
            name: 'LinkedIn',
            href: 'https://linkedin.com/company/merilite/',
            icon: (
                <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                    <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/>
                    <circle cx="4" cy="4" r="2"/>
                </svg>
            ),
        },
        {
            name: 'X',
            href: 'https://x.com/meriliteX',
            icon: (
                <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
            ),
        },
        // {
        //     name: 'WhatsApp',
        //     href: 'https://whatsapp.com/channel',
        //     icon: (
        //         <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
        //             <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
        //             <path d="M12 0C5.373 0 0 5.373 0 12c0 2.124.558 4.17 1.6 5.943L.057 23.882a.5.5 0 00.612.612l5.939-1.543A11.945 11.945 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22a9.944 9.944 0 01-5.127-1.42l-.362-.214-3.755.976.999-3.648-.235-.375A9.944 9.944 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
        //         </svg>
        //     ),
        // },
        // {
        //     name: 'YouTube',
        //     href: 'https://youtube.com',
        //     icon: (
        //         <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
        //             <path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 00-1.95 1.96A29 29 0 001 12a29 29 0 00.46 5.58A2.78 2.78 0 003.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 001.95-1.95A29 29 0 0023 12a29 29 0 00-.46-5.58z"/>
        //             <polygon fill="#1a1f5e" points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02"/>
        //         </svg>
        //     ),
        // },
    ];

    return (
        <footer className={styles.footer}>
            <div className={styles.inner}>

                {/* Top section */}
                <div className={styles.top}>
                    <div className={styles.brand}>
                        <span className={styles.logo}>Merilite</span>
                        <p className={styles.tagline}>Connect with learners from Your School, Coaching and College. Knowledge shared is knowledge multiplied.</p>
                    </div>

                    <div className={styles.columns}>
                        <div className={styles.col}>
                            <h4 className={styles.colTitle}>Platform</h4>
                            {/* <a href="/" className={styles.link}>Browse Tutors</a>
                            <a href="/" className={styles.link}>Become a Tutor</a> */}
                            <a href="/how-it-works" className={styles.link}>How It Works</a>
                            {/* <a href="/" className={styles.link}>Pricing</a> */}
                        </div>
                        <div className={styles.col}>
                            <h4 className={styles.colTitle}>Support</h4>
                            <a href="/contact-us" className={styles.link}>Contact Us</a>
                            <a href="/" className={styles.link}>Help Center</a>
                            <a href="/" className={styles.link}>Community</a>
                            <a href="/" className={styles.link}>Report an Issue</a>
                        </div>
                        <div className={styles.col}>
                            <h4 className={styles.colTitle}>Legal</h4>
                            <a href="/privacy-policy" className={styles.link}>Privacy Policy</a>
                            <a href="/" className={styles.link}>Terms of Service</a>
                            <a href="/" className={styles.link}>Cookie Policy</a>
                        </div>
                    </div>
                </div>

                <div className={styles.divider} />

                {/* Bottom section */}
                <div className={styles.bottom}>
                    <p className={styles.copy}>© {new Date().getFullYear()} LearnTeach. All rights reserved.</p>

                    <div className={styles.socials}>
                        {socials.map((s) => (
                            <a
                                key={s.name}
                                href={s.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.socialBtn}
                                title={s.name}
                            >
                                {s.icon}
                            </a>
                        ))}
                    </div>
                </div>

            </div>
        </footer>
    );
};

export default Footer;